import { useSelector } from 'react-redux';
import betslip from '@gin-betting/betslip';
import { createSelector } from 'reselect';

import { State } from 'types';

const {
    selectors: { selectChosenBetslipBet },
} = betslip;

interface Output {
    betsSize: number | null;
}

const selectBetsSize = createSelector(selectChosenBetslipBet, betslipBet => {
    if (!betslipBet) return null;

    const { betslipOddIds } = betslipBet;

    return betslipOddIds.count();
});

const useBetCount = (): Output => {
    const betsSize = useSelector((s: State) => selectBetsSize(s));

    return { betsSize };
};

export default useBetCount;
